import { render, staticRenderFns } from "./Bibliography.vue?vue&type=template&id=0039d32e&"
import script from "./Bibliography.vue?vue&type=script&lang=js&"
export * from "./Bibliography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports